import {
  NEXT_PUBLIC_CHATWOOT_BASE_URL,
  NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN,
} from 'utils/constants';

type ChatwootUser = {
  email?: string;
  name?: string;
  accountType?: string;
};

declare global {
  interface Window {
    chatwootSDK?: {
      run: (config: { websiteToken: string; baseUrl: string }) => void;
    };
    $chatwoot?: {
      setUser: (
        identifier: string,
        user: { email?: string; name?: string; identifier_hash?: string }
      ) => void;
      setCustomAttributes: (attributes: Record<string, string>) => void;
      toggle: (state?: 'open' | 'close') => void;
      reset: () => void;
    };
  }
}

let isLoaded = false;

const identifyUser = async (user: ChatwootUser) => {
  // The identifier is signed server side so users cannot impersonate each other.
  const res = await fetch('/api/chatwoot-identity', {
    credentials: 'same-origin',
  });

  if (!res.ok) {
    return;
  }

  const { identifier, identifierHash } = await res.json();

  window.$chatwoot?.setUser(identifier, {
    email: user.email,
    name: user.name,
    identifier_hash: identifierHash,
  });
  window.$chatwoot?.setCustomAttributes({
    account_type: user.accountType ?? '',
  });
};

export const loadChatwoot = (user: ChatwootUser) => {
  if (
    isLoaded ||
    !NEXT_PUBLIC_CHATWOOT_BASE_URL ||
    !NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN
  ) {
    return;
  }

  isLoaded = true;

  window.addEventListener('chatwoot:ready', () => {
    // eslint-disable-next-line no-console
    identifyUser(user).catch(console.log);
  });

  const script = document.createElement('script');
  script.src = `${NEXT_PUBLIC_CHATWOOT_BASE_URL}/packs/js/sdk.js`;
  script.async = true;
  script.onload = () => {
    window.chatwootSDK?.run({
      websiteToken: NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN,
      baseUrl: NEXT_PUBLIC_CHATWOOT_BASE_URL,
    });
  };
  document.body.appendChild(script);
};

export const openSupportChat = () => {
  window.$chatwoot?.toggle('open');
};

export const resetChatwoot = () => {
  window.$chatwoot?.reset();
};
